import { toast } from "react-toastify";
import { getToken } from "../utility/Constant";

export const updateData = (api, data, patch, login, navigate, post) => {
  const requestOptions = {
    method: patch ? "PATCH" : post ? "POST" : "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
    body: JSON.stringify(data),
  };
  fetch(`${process.env.REACT_APP_API_URL}/${api}`, requestOptions)
    .then(async (response) => {
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson && (await response.json());
      let success = "";

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response status
        const error = data.error;
        return Promise.reject(error);
      } else {
        success = data.message;
        window.location.reload();
      }

      toast.success(success, {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      if (login) {
        sessionStorage.setItem(
          "ebc202c5c66c906f41dfee622fb64221",
          data.data.token
        );
        navigate("/");
      }
    })
    .catch((error) => {
      console.log(error);
      toast.error(error, {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    });
};
